import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import JhiFormatter from './formatter';
import { setupAxiosInterceptors } from '@/shared/config/axios-interceptor';

import VueCookies from 'vue-cookies';
import Vuelidate from 'vuelidate';
import Vue2Filters from 'vue2-filters';

import { accountStore } from '@/store/account-store';
import { translationStore } from '@/store/translation-store';
import { loginStore } from '@/store/login-store';
import { consentStore } from '@/store/consent-store';
import createPersistedState from 'vuex-persistedstate';

export function initVueApp(vue) {
  vue.use(VueCookies);

  vue.use(Vuelidate);
  vue.use(Vue2Filters);
  setupAxiosInterceptors(() => {
    console.log('Unauthorized!');
  });
}

export function initFortAwesome(vue) {}

export function initI18N(vue) {
  vue.use(VueI18n);
  return new VueI18n({
    silentTranslationWarn: true,
    formatter: new JhiFormatter()
  });
}

export interface RootState {
  root: string;
}

export function initVueXStore(vue) {
  vue.use(Vuex);
  return new Vuex.Store({
    state: {} as RootState,
    modules: {
      accountStore,
      translationStore,
      loginStore,
      consentStore
    },
    plugins: [createPersistedState({ storage: window.sessionStorage, paths: ['translationStore', 'loginStore', 'consentStore'] })]
    //be aware to persist store - accountStore must not be added
  });
}
